/*
 * Wires the mobile search icon button to the mobile <predictive-search>
 * instance (the one rendered with `is_mobile_trigger: true` in
 * snippets/header-search.liquid, marked with the `.mobile-search-instance`
 * class). That instance starts completely hidden (no visible search bar on
 * mobile at all - see component-predictive-search.css) and becomes a
 * fullscreen fixed panel once its own onFocus() runs, exactly mirroring
 * pni-bulgaria's `predictive-search-mob-trigger` pattern: the icon calls
 * onFocus() directly (rather than trying to `.focus()` a still-hidden,
 * unfocusable input), which flips the panel visible and focuses the input
 * itself as its very last step.
 */
document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.querySelector('.mobile-search-open');
  const mobileSearch = document.querySelector('predictive-search.mobile-search-instance');

  if (trigger && mobileSearch) {
    trigger.addEventListener('click', () => {
      mobileSearch.onFocus();
    });
  }
});
